
class Country {
  constructor(
    readonly id: string,
    readonly title: string,
    readonly geographicRegion: string,
    readonly countryCodeTopLevelDomain: string,
  ) {}
}

export default Country;
